import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import type { ShowroomInformations } from '@app/_services/account.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService,IndividualConfig } from 'ngx-toastr';

import { first } from 'rxjs/operators';
import { InstoreService, AccountService } from '@app/_services'; 
import * as moment from 'moment';
import { NgxSpinnerService } from "ngx-spinner";   

@Component({
  selector: 'app-addcampaign',
  templateUrl: './addcampaign.component.html',
  styleUrls: ['./addcampaign.component.css']
})
export class AddcampaignComponent implements OnInit {

  private format = 'YYYY-MM-DD';

  form: UntypedFormGroup;
  submitted = false;
  isLoading = false;
  City: any = ['Option 1', 'Option 2', 'Option 3']

  RegionDataLists;
  ShowroomDataLists: ShowroomInformations[] = [];
  FilterShowroomLists;
  selRegionValue: number;
  AssetsDataLists;
  CreativeDataLists;
  VendorDataListsl;
  FestivalDataLists;

  selFestivalValue: number;
  minDate: any;

  constructor(private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private instoreService: InstoreService,
    private accountService: AccountService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private router: Router,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {

    console.log("getuserdata "+localStorage.getItem('user'));

    this.route.queryParams.subscribe(params => {
      //this.userWithRole.user = JSON.parse(params["user"]);
      console.log("AddinstoreComponent"+JSON.parse(params["user"]));
    });

    this.form = this.formBuilder.group({
      festival_id: ['', Validators.required],
      particulars: ['', Validators.required], //m
      region_id: ['', Validators.required], //m
      showroom_id: ['', Validators.required], //m
      asset_type_id: ['', Validators.required], //m
      creative_id: ['', Validators.required], //m
      vendor_id: ['', Validators.required], //m
      name : ['', Validators.required], //m
      size_w: ['', Validators.required], //m
      size_h: ['', Validators.required], //m
      install_date: ['', Validators.required], //m
      expiry_date: ['', Validators.required], //m
      image: [''],
      cost: ['', Validators.required]
    });

    this.reloadFestivalLists()
    this.reloadRegionLists()
    this.reloadShowroomLists()
    this.reloadAssetsLists()
    this.reloadCreativeLists()
    this.reloadVendorLists()
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit(modal_id: string) {
    this.submitted = true;

    if(!this.form.valid){
      console.log("Form is not valid"+this.form.errors);
      return;
    } 

    this.spinner.show();
    this.isLoading = true;

    this.form.get("install_date").setValue(moment(this.f.install_date.value).format(this.format)); //Working
    this.form.get("expiry_date").setValue(moment(this.f.expiry_date.value).format(this.format)); //Working

    console.log("Onsubmnit");

    const formDataNew = new FormData();  
    formDataNew.append('festival_id', this.form.get('festival_id').value);
    formDataNew.append('festival_name', this.form.get('name').value);
    formDataNew.append('region_id', this.form.get('region_id').value);
    formDataNew.append('showroom_id', this.form.get('showroom_id').value);
    formDataNew.append('start_date', this.form.get('install_date').value);

    formDataNew.append('end_date', this.form.get('expiry_date').value);
    formDataNew.append('creative_id', this.form.get('creative_id').value);
    formDataNew.append('size_w', this.form.get('size_w').value);
    formDataNew.append('size_h', this.form.get('size_h').value);
    formDataNew.append('asset_type_id', this.form.get('asset_type_id').value);

    formDataNew.append('particulars', this.form.get('particulars').value);
    formDataNew.append('image', this.form.get('image').value);
    formDataNew.append('vendor_id', this.form.get('vendor_id').value);
    formDataNew.append('cost', this.form.get('cost').value);

    for (let [key, value] of formDataNew.entries()) {
      console.log(key, ':', value);
     }
    
     this.instoreService.addCampaign(formDataNew)
     .pipe(first())
     .subscribe({
         next: () => { 
             this.openModal(modal_id);
             this.onReset()
             this.spinner.hide();
         },
         error: error => {
             this.toastr.warning("Sorry, something went wrong Please try again", "Warning");              
             this.onReset()
             this.spinner.hide();
         }
     });
  }

  imageSrc: string;

  onFileChange(event) {
    const reader = new FileReader();
    
    if(event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageSrc = reader.result as string;
        this.form.get('image').setValue(event.target.files[0]);
        /*
        this.form.patchValue({
          fileSource: reader.result
        });
        */
   
      };
   
    }
  }

  onFestivalChange(festivalValue) {
    this.selFestivalValue =  parseInt(festivalValue, 10);
    let filterLists = this.FestivalDataLists.filter(s => s.id === this.selFestivalValue);

    if(filterLists.length > 0) {
      this.form.patchValue({
        name: filterLists[0].name
      });
    }


  }

  onRegionChange(regionValue) {
      this.selRegionValue =  parseInt(regionValue, 10);
      this.resetShowroom()
      this.FilterShowroomLists = this.ShowroomDataLists.filter(s => s.region_id === this.selRegionValue);
  }

  resetShowroom() {
    this.form.patchValue({
      showroom_id: ''
    });
  }
  

  reloadFestivalLists(){
    this.accountService.getFestivalLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.FestivalDataLists = response.result;
        console.log("RegionDataLists List "+this.FestivalDataLists.length);
        for(var i = 0; i < this.FestivalDataLists.length; i++){
          console.log("this.RegionDataLists "+this.FestivalDataLists[i].id);
       }
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

  reloadRegionLists(){
    this.accountService.getRegionsLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.RegionDataLists = response.result;
        console.log("RegionDataLists List "+this.RegionDataLists.length);
        for(var i = 0; i < this.RegionDataLists.length; i++){
          console.log("this.RegionDataLists "+this.RegionDataLists[i].id);
       }
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

  reloadShowroomLists(){
    this.accountService.getShowroomLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.ShowroomDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }


  reloadAssetsLists(){
    this.accountService.getAssetsLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.AssetsDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

  reloadCreativeLists(){
    this.accountService.getCreativeLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.CreativeDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  
   reloadVendorLists(){
    this.accountService.getVendorLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.VendorDataListsl = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

  installChange(event) {
    if(event.value){
      //console.log("Date of Birth: " + moment(event.value).format(this.format) );
      //this.selInstallDate =  moment(event.value).format(this.format);
      //this.filterForInstore()
      this.minDate = event.value;
      this.resetExpiry();

    } else {
      //this.selInstallDate = "";
      //this.filterForInstore()
    }
  }  

  resetExpiry() {
    this.form.patchValue({
      expiry_date: ''
    });
  }

  onReset(){
    this.submitted = false;
    this.imageSrc = null;
    this.form.reset();
  }

  closeResult :string
  openModal(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',size: 'md'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

}
